import React, { Component } from 'react';

import { Container, Row, Col } from 'react-bootstrap';

import * as fn from '../library/function';
import * as constants from '../config/constants/AppConstants';
import * as helper from '../library/helper';
import * as util from '../library/utilitys';

import CommonPageHeader from './components/CommonPageHeader';
import CommonToolbar from './components/CommonToolbar';
import CommonToast from './components/CommonToast';
import CommonConfirmModal from './components/CommonConfirmModal';

import CommonTokenExpired from './components/CommonTokenExpired';

import Cookies from "js-cookie";

/** withRouter */
import withRouter from "./components/withRouter";

/** start individual component */
import InputSupplyDataSupplyHr from './inputs/InputSupplyDataSupplyHr';
import SearchSupplyDataSupplyHr from './searchs/SearchSupplyDataSupplyHr';
import DataTableSupplyDataSupplyHr from './dataTables/DataTableSupplyDataSupplyHr';
/** end individual component */

import * as Actions from './actions/ActionCenter';

import { GlobalStates } from './states/GlobalStates';

/** individual page state */
import { PageDataState } from './states/SupplyDataSupplyHrState';

/** requester handle */
import requester from "../library/Requester"; 

/** define end point */
const TABLE = `supply_hr`;
const URL = `api/master/${TABLE}`;

const rawProfile = Cookies.get("userProfile");
const userProfile = rawProfile ? JSON.parse(rawProfile) : {};

class SupplyDataSupplyHr extends Component {

    constructor(props){
        super(props);

        this.state = {...GlobalStates, ...PageDataState};
        this.updateState = this.setState.bind(this);
    }

    initialize = async () => {
        await this.loadMasterbase();
        await this.loadDataTable();
        await this.setDefaultSearchs();
    }

    loadMasterbase = async () => {
        let sets = [
            {key: "academy", filter: [{field: "status", value: "0"}]}, 
            {key: "faculty", filter: [{field: "status", value: "0"}]},
            {key: "department", filter: [{field: "status", value: "0"}]},
            {key: "department_work", filter: [{field: "status", value: "0"}]} 
        ];

        Actions.loadMasterbase(this.updateState, sets);
    }

    loadDataTable = async (search = false) => {
        const { Searchs, DataTable } = this.state;

        const cookieSearchs = {};
        
        if (userProfile.academy_id && !["0","1"].includes(userProfile.types))  {
            cookieSearchs.academy_id = { id: "academy_id", value: userProfile.academy_id };
        }
        
        const mergedSearchs = {
            ...Searchs,
            ...cookieSearchs,
            page: {
                id: "page",
                value: search ? 1 : DataTable.pagination.currentPage,
            },
        };

        await Actions.loadDataTable(
            this.updateState,
            `${URL}/pagination`,
            fn.getInputSearch(mergedSearchs)
        );
    }

    setDefaultSearchs = async () => {
        let defaultsSearchs = {};
         switch (userProfile.types) {
            case "2": // academy
                defaultsSearchs.academy_id = userProfile.academy_id;
            break;
            default:
                //(admin) ไม่เซ็ตค่า
            break;
        }
        await Actions.setDefaultSearchs(this.updateState,defaultsSearchs); 
        
    }

    navigate = (type, obj) => {        
        const { Searchs, DataTable, Operation } = this.state; 
        
        const route = `supply-human-resource-${type}`;

        const key = `supply_hr`;

        Actions.navigate(this.props.navigate, `/apps/${route}`, {
            direction: 'drilldown',
            key: key,
            restore: {},
            [key]: {
                parameters: {...obj},
                searchs: Searchs,
                operation: Operation,
                currentPage: DataTable.pagination.currentPage,
            },
        });
    };

    fetchForEdit = async (obj) => {
        await Actions.fetchForEdit(
            this.updateState,
            `${URL}/${obj.id}`, 
            {element: 'OffCanvas', mode: 'update', bool: true}
        );
    }

    deleteData = async () => {
        const { Deletes } = this.state;
        await Actions.deleteData(this.updateState, `${URL}`, Deletes, this.loadDataTable);
    }

    submitData = async () => {
        const { Action, Inputs, DataTable } = this.state;
    
        const payload = fn.getInputForm({ ...Inputs });
    
        await Actions.submitData(
            this.updateState,
            URL,
            Action.Mode,
            payload,
            this.loadDataTable,
            null,
            false            
        );
    }

    setDefaultInputs = async () => {
        await Actions.setProfileInputs(this.updateState, {
            academy_id: "academy_id",
        });
    }

    parametersControl = async (state) => {
        if (state) {
            const { direction, key, restore, ...object } = state;
            await Actions.parametersPrompt(this.updateState, key, object[key], restore);
        }
    
        const shouldInitialize = !!state; 
        if (shouldInitialize) {
            await this.initialize();
        }
    };

    componentDidMount = async () => {
        const state = this.props.location.state || {} ;
        
        if (util.isObject(state)){
            this.parametersControl(state); 
        } else {
            await this.initialize(); 
        }
    }

    componentDidUpdate = async () => {}    

    render = () => {

        let { Action, Searchs, DataTable, Inputs, InputGroup, Masterbase, Deletes, Operation, Token } = this.state;

        let AppProps = constants.AppProps[helper.getCurrentRoute()];

        return (
            <>
                <Container>

                    <CommonPageHeader object={AppProps}/>

                    <CommonTokenExpired Token={Token} />

                    <CommonToolbar 
                        config={AppProps.toolbar}
                        
                        Operation={Operation}
                        Deletes={Deletes}

                        onToggleSearch={(e) => Actions.handleToggleItem(this.updateState, 'Operation', 'Search')}

                        onRefreshDataTable={async (e) => await this.loadDataTable()}
                        
                        onCreateItem={(e) => Actions.handleOpenInputForm(this.updateState, 'OffCanvas', 'new', true, this.setDefaultInputs)}
                        onModalAction={(e) => Actions.handleControlModal(this.updateState, e)}
                    />

                    <CommonToast 
                        toast={Action.Toast} 

                        onCloseToast={(e) => Actions.handleCloseToast(this.updateState)}
                    />

                    <CommonConfirmModal 
                        Action={Action}
                        Deletes={Deletes}

                        onCallback={async (e) => { 
                            let result = await Actions.handleControlModal(this.updateState, e);
                            if(result.action){
                                if (result.section === 'Delete'){ await this.deleteData(); }
                            }
                         }}
                    />

                    <SearchSupplyDataSupplyHr 
                        Action={Action}
                        Searchs={Searchs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onSearch={async (e) => await this.loadDataTable(true)}
                    />

                    <DataTableSupplyDataSupplyHr 
                        Action={Action}
                        DataTable={DataTable}
                        Inputs={Inputs}
                        Deletes={Deletes}
                        Operation={Operation}

                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        onDropDownChange={async(type, e, element, pk) => { 
                            let obj = { element: [{id: pk.key, value: pk.value, label: pk.label}]}
                            this.navigate(e.target.value, obj); 
                        }}

                        onCheckDelete={(e) => Actions.handleDataTableToggleDelete(this.updateState, e)}
                        onCheckDeleteAll={(e, deletes) => Actions.handleDataTableToggleDeleteAll(this.updateState, e, deletes)}
                        onPaginationChange={(paging) => Actions.handleDataTablePaginationChange(this.updateState, paging, this.loadDataTable)}
                    />

                    <InputSupplyDataSupplyHr 
                        URL={URL}
                        
                        App={AppProps}

                        Action={Action}
                        Inputs={Inputs}
                        InputGroup={InputGroup}
                        Masterbase={Masterbase}
                        Operation={Operation}
                        UserCookie={userProfile}

                        onUpdateState={(key, value) => Actions.updateState(this.updateState, key, value)}
                        onInputChange={(e, element) => Actions.handleInputChange(this.updateState, element, e)}

                        onCloseAlert={(e) => { Actions.handleCloseAlert(this.updateState, 'Alert', e); }}
                        onSubmit={async (e) => { await this.submitData()}}
                        
                        onSetEdit={async (e, obj) => { await this.fetchForEdit(obj); }}
                        
                        onDiscardSubmit={(e) => { Actions.handleDiscardInputs(this.updateState, 'Inputs'); }}
                        onClose={(e) => {
                                Actions.handleDiscardInputs(this.updateState, 'Inputs');
                                Actions.handleCloseInputForm(this.updateState, 'OffCanvas');
                            }
                        }
                    />
                </Container>
            </>
        )
    }
}

export default withRouter(SupplyDataSupplyHr);